/******************************************
 *  Author : Suraj Sharma
 *  Created On : Wed Feb 17 2021
 *  File : index.jsx
 *******************************************/
import React from 'react';
import { useSelector } from 'react-redux';
import fetch from 'node-fetch';

import {API_SERVER_BASE, apiEndPoints} from '../../config/constants/ApiServiceConstants';
import authStatuses from '../../config/constants/AuthConstants';
import PreAuthMap from '../preAuthMap';
import PostAuthMap from '../postAuthMap';

/**
 * We have two forest pages preAuthMap and 
 * postAuthMap. Depending on the authentication state
 * we will server either of them
 */

const MANAGE_USER_URL = `${API_SERVER_BASE}/${apiEndPoints.userInfo}`;

const Index = props => {
    const { authStatus } = useSelector((state) => state.authReducer);
    if (authStatus === authStatuses.LOGGED_OUT) {
        return <PreAuthMap {...props} />;
    }
    return <PostAuthMap {...props} />;
}

Index.getInitialProps = async (ctx) => {
    const {query} = ctx;
    const {
        count,
        transaction_system,
        transaction_id,
        restaurant_name,
        restaurant_id,
        email,
        switcherState
    } = query;

    let result = {};
    if(email !== undefined){
        const requestOptionsget = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({           
                'email': email
            })
        };
        const response = await fetch(
            MANAGE_USER_URL, 
            requestOptionsget
        );
        result = await response.json();
    }

    return {
        count,
        transaction_system,
        transaction_id,
        restaurant_name,
        restaurant_id,
        email,
        switcherState,
        userExists: Object.keys(result).length > 0 && result.data !== null ? true : false
    }
}

export default Index;